module.exports = __webpack_public_path__ + "4bcf8478fbba86b1732b063a2f8db77d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/velikonocni-tabor-6.jpg
// module id = 1206
// module chunks = 0